query ApprovalsInfo(
  $first: Int
  $after: Cursor
  $orderBy: [ApprovalsOrderBy!]
  $filter: ApprovalFilter
) {
  approvals(first: $first, after: $after, orderBy: $orderBy, filter: $filter) {
    nodes {
      id
      badgeColor
      __typename
      _rowTimestamp
      _fullApprovalDescription
      priorityNumber
      description
      _infoLines {
        infoLine4
        infoLine3
        infoLine2
        infoLine1
        isTested
        activeTestCount
      }
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
  }
}
